import { FC, ReactNode } from 'react';
import { Box } from '../Box';

import styles from './index.module.css';

interface ClassNames {
  wrapperClass?: string;
  contentClass?: string;
}

interface OverlayProps {
  children?: ReactNode;
  classNames?: ClassNames;
  onClick?: () => void;
}

export const Overlay: FC<OverlayProps> = ({
  children,
  classNames = {},
  onClick = () => {}
}) => {
  const { wrapperClass = '', contentClass = '' } = classNames;

  return (
    <Box className={`${styles.overlay} ${wrapperClass}`} onClick={onClick}>
      {children && (
        <Box
          align="center"
          justify="center"
          className={`${styles.content} ${contentClass}`}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};
